import React, { useState } from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Navbar from '../common/Navbar';
import AssessmentCreate from './AssessmentCreate';
import AssessmentList from './AssessmentList';
import CandidateCreate from './CandidateCreate';
import CandidateList from './CandidateList';
import AssignmentCreate from './AssignmentCreate';
import GradingInterface from './GradingInterface';
import ViewerCreate from './ViewerCreate';
import ViewerList from './ViewerList';
import ViewerAssignmentCreate from './ViewerAssignmentCreate';
import EvaluationLab from './EvaluationLab';

const AdminDashboard = ({ user, onLogout }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const [refreshAssessments, setRefreshAssessments] = useState(0);
  const [refreshCandidates, setRefreshCandidates] = useState(0);
  const [refreshViewers, setRefreshViewers] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleAssessmentCreated = () => {
    setRefreshAssessments((prev) => prev + 1);
  };

  const handleCandidateCreated = () => {
    setRefreshCandidates((prev) => prev + 1);
  };

  const handleViewerCreated = () => {
    setRefreshViewers((prev) => prev + 1);
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <Navbar user={user} onLogout={onLogout} />

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom color="primary">
          {t('admin.dashboard')}
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={currentTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
            <Tab label={t('admin.tabs.assessments')} />
            <Tab label={t('admin.tabs.candidates')} />
            <Tab label={t('admin.tabs.viewers')} />
            <Tab label={t('admin.tabs.assignments')} />
            <Tab label={t('admin.tabs.grading')} />
            <Tab label={t('admin.evaluationLab.title')} />
          </Tabs>
        </Box>

        {/* Assessments Tab */}
        {currentTab === 0 && (
          <Box>
            <Box sx={{ mb: 3 }}>
              <AssessmentCreate onAssessmentCreated={handleAssessmentCreated} />
            </Box>
            <AssessmentList refresh={refreshAssessments} />
          </Box>
        )}

        {/* Candidates Tab */}
        {currentTab === 1 && (
          <Box>
            <Box sx={{ mb: 3 }}>
              <CandidateCreate onCandidateCreated={handleCandidateCreated} />
            </Box>
            <CandidateList refresh={refreshCandidates} />
          </Box>
        )}

        {/* Viewers Tab */}
        {currentTab === 2 && (
          <Box>
            <Box sx={{ mb: 3 }}>
              <ViewerCreate onViewerCreated={handleViewerCreated} />
            </Box>
            <Box sx={{ mb: 3 }}>
              <ViewerList refresh={refreshViewers} />
            </Box>
            <ViewerAssignmentCreate />
          </Box>
        )}

        {/* Assignments Tab */}
        {currentTab === 3 && (
          <Box>
            <AssignmentCreate />
          </Box>
        )}

        {/* Grading Tab */}
        {currentTab === 4 && (
          <Box>
            <GradingInterface />
          </Box>
        )}
        {currentTab === 5 && <EvaluationLab />}
      </Container>
    </Box>
  );
};

export default AdminDashboard;
